import { getPageTitle } from '@/components/layouts/page-titles'

export const APP_NAME = 'BidContext'

/** Any route under a specific bid — `/app/bids/:bidId/...`. */
const BID_ROUTE = /^\/app\/bids\/([^/]+)/

/**
 * "Bids" → "Bids - BidContext". An empty label (or the app name itself)
 * collapses to the bare app name so we never render "BidContext - BidContext".
 *
 * Hyphen, not an em dash: Google names hyphen/colon/pipe as title separators,
 * and the em dash is the widest glyph in the font — wasted pixels in a SERP
 * title truncated by width and a tab truncated at ~20 chars.
 */
export function formatDocumentTitle(page?: string | null): string {
  const label = page?.trim()
  if (!label || label === APP_NAME) return APP_NAME
  return `${label} - ${APP_NAME}`
}

/**
 * Document title for an authenticated route. Bid-scoped routes are titled with
 * the bid name once it has loaded — deliberately one title per bid, not one per
 * tab within the bid, so parallel tabs are distinguishable without churn.
 */
export function resolveDocumentTitle(
  pathname: string,
  selectedBid: { id: string; title: string } | null | undefined
): string {
  const bidMatch = BID_ROUTE.exec(pathname)
  if (bidMatch) {
    const bidId = bidMatch[1]
    const loaded = selectedBid && selectedBid.id === bidId ? selectedBid.title.trim() : ''
    return formatDocumentTitle(loaded || 'Bid')
  }

  return formatDocumentTitle(getPageTitle(pathname))
}
